import React from 'react';

import { Box } from '@mui/material';

import { PatientAppointmentServiceItem, PaymentTypeName, ServiceItemPaymentStatus } from '@uplift/api';
import { DescriptionOfService } from './DescriptionOfService.component';
import { BillingDetails, BillingResponsibilityItem, getInsuranceBillingReportItems } from './BillingDetails.component';
import { WhatDoTheseTermMeans } from './WhatDoTheseTermMeans.components';
import { AppointmentState } from '@uplift/types';
import { mobileBreakpoint, useIsMobile } from '@uplift/hooks';
import { SessionDetailsDescription } from './SessionDetailsDescription.component';


export const useAppointmentServiceResponsibilities = (row: PatientAppointmentServiceItem) => {
  const {
    payment,
    service: {
      appointment,
    }
  } = row;

  return React.useMemo(() => {
    const result: BillingResponsibilityItem[] = [];

    if (payment?.type === PaymentTypeName.insurance) {
      return getInsuranceBillingReportItems(payment);
    }

    if (!payment) {
      if (appointment.state === AppointmentState.cancelled) {
        result.push({ title: 'Late cancellation fee', value: 0 });
      }
    }

    if (payment?.type === PaymentTypeName.cash) {
      if (row.payment?.status === ServiceItemPaymentStatus.canceled) {
        result.push({ title: 'Late cancellation fee', value: 0 });
      } else if (appointment.state === AppointmentState.cancelled) {
        result.push({ title: 'Late cancellation fee', value: payment.payment?.amountCents });
      } else {
        result.push({ title: 'Your responsibility', value: payment.payment?.amountCents });
      }
    }

    return result;
  }, [ payment, appointment, row ]);
};


export const AppointmentServiceDetails = ({ row }: { row: PatientAppointmentServiceItem }) => {
  const isMobile = useIsMobile(mobileBreakpoint);
  const {
    payment,
    service: {
      cptCodes,
    }
  } = row;

  const responsibilities = useAppointmentServiceResponsibilities(row);

  return (
    <Box display="flex" flexDirection={{ xs: 'column', sm: 'row' }}>
      {isMobile && (
        <Box mt={3}>
          <SessionDetailsDescription row={row} />
        </Box>
      )}
      <Box flex={1} display="flex" flexDirection="column" mt={{ xs: 5, sm: 0 }}>
        <Box flex={1}>
          <BillingDetails
            serviceItemStatus={row.status}
            billing={payment}
            responsibilities={responsibilities}
          />
        </Box>
        {!isMobile && (
          <Box mt={4} display="flex" justifyContent="flex-start">
            <WhatDoTheseTermMeans serviceItem={row} />
          </Box>
        )}
      </Box>
      <Box flex={1} mt={{ xs: 5, sm: 0 }}>
        <DescriptionOfService cptCodes={cptCodes} />
      </Box>
      {isMobile && (
        <Box px={2} my={4} display="flex" justifyContent="flex-start">
          <WhatDoTheseTermMeans serviceItem={row} />
        </Box>
      )}
    </Box>
  );
};
